import React from "react";
import ThreadDetailsHeader from "./thread-details-header/threadDetailsHeader";
import { useThreadDetails } from "./useThreadDetails";
import ThreadDetailsMessages from "./thread-details-messages/threadDetailsMessages";
import { Loader2 } from "lucide-react";

interface ThreadDetailsProps {}

const ThreadDetails: React.FC<ThreadDetailsProps> = () => {
  const {
    thread,
    loading,
    handleTogglePin,
    handleToggleArchive,
    isEditingTitle,
    setIsEditingTitle,
    titleDraft,
    setTitleDraft,
    savingTitle,
    handleSaveTitle,
  } = useThreadDetails();

  return (
    <>
      {loading && (
        <div className="flex flex-grow justify-center items-center h-full">
          <Loader2 className=" text-primary-700" />
        </div>
      )}

      <div className="m-5 h-full flex flex-col mt-0 mb-0 rounded-2xl">
        {!loading && (
          <>
            <ThreadDetailsHeader
              thread={thread}
              loading={loading}
              handleTogglePin={handleTogglePin}
              handleToggleArchive={handleToggleArchive}
              isEditingTitle={isEditingTitle}
              setIsEditingTitle={setIsEditingTitle}
              titleDraft={titleDraft}
              setTitleDraft={setTitleDraft}
              savingTitle={savingTitle}
              handleSaveTitle={handleSaveTitle}
            />
            <ThreadDetailsMessages thread={thread} />
          </>
        )}
      </div>
    </>
  );
};

export default ThreadDetails;
